import type { ApolloError } from '@apollo/client/errors';
import { json } from 'react-router-dom';

export const notFound = (slug: string | undefined) =>
  json({ slug }, { status: 404, statusText: 'Not found' });

export const internalError = (error?: ApolloError) =>
  json({ message: error ? error.message : 'Internal error' }, { status: 500 });
